import jsPDF from 'jspdf'
import { renderToPdf } from './renderToPdf'

export const generateZReportPdf = async (report, reportCashData, company, t, currencyLocale, currencyCode) => {
	const pdf = new jsPDF({
		orientation: 'p', unit: 'px', format: 'a4', hotfixes: ['px_scaling'],
	})
	return renderToPdf(pdf, report, reportCashData, company, t, currencyLocale, currencyCode)
}
